import { render, staticRenderFns } from "./cAdminDocClassifierRules.vue?vue&type=template&id=a97c48da&scoped=true"
import script from "./cAdminDocClassifierRules.vue?vue&type=script&lang=js"
export * from "./cAdminDocClassifierRules.vue?vue&type=script&lang=js"
import style0 from "./cAdminDocClassifierRules.vue?vue&type=style&index=0&id=a97c48da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97c48da",
  null
  
)

export default component.exports